<div class="companies-acess">
    <div class="section-toolbar">
        <span class="section-hint">Ative as empresas que o usuário pode acessar</span>
        <nz-input-group class="filter-field" [nzPrefix]="searchIcon" [nzSuffix]="clearIcon">
            <input nz-input placeholder="Filtrar empresas" [(ngModel)]="companyInputFilter" (keyup)="updateFilterCompanies()" />
        </nz-input-group>
        <ng-template #searchIcon><nz-icon nzType="search"></nz-icon></ng-template>
        <ng-template #clearIcon>
            <nz-icon *ngIf="companyInputFilter" class="clear-icon" nzType="close-circle" nzTheme="fill" (click)="clearFilter()"></nz-icon>
        </ng-template>
    </div>
    <div class="grid-box">
        <div class="grid-row grid-header cols-companies">
            <div>Código</div>
            <div>Nome</div>
            <div>Permitir</div>
        </div>
        <nz-spin [nzSpinning]="loadingDataCompany">
            <div class="rows-scroll viewport-companies">
                <div class="grid-row cols-companies"
                    *ngFor="let acess of companiesAcessData"
                    [class.row-selected]="acess === selectedCompany"
                    (click)="selectedCompany = acess">
                    <div>{{acess.id}}</div>
                    <div class="cell-ellipsis" nz-tooltip [nzTooltipTitle]="acess.name">{{acess.name}}</div>
                    <div (click)="$event.stopPropagation()">
                        <nz-switch nzSize="small" [ngModel]="!!acess.enable" (ngModelChange)="changeAcess($event, acess)"></nz-switch>
                    </div>
                </div>
                <nz-empty *ngIf="!loadingDataCompany && companiesAcessData.length === 0" nzNotFoundContent="Nenhuma empresa encontrada"></nz-empty>
            </div>
        </nz-spin>
    </div>
</div>
